import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import type { DeepPartial, FieldValues, UseFormWatch } from "react-hook-form";
import { replaceEmptyStringWithUndefined } from "./object";

export const useSubscribeFromValues = <T extends FieldValues>(
  callback: (values: DeepPartial<T>) => void,
  watch: UseFormWatch<T>,
  logging = false,
) => {
  useEffect(() => {
    const subscription = watch((values) => {
      if (logging) {
        console.log("[useSubscribeFromValues] values changed", values);
      }
      callback(values);
    });
    return () => subscription.unsubscribe();
  }, [watch, callback, logging]);
};

export const customZodResolver: typeof zodResolver = (...args) => {
  return async (values, context, options) => {
    return zodResolver(...args)(
      replaceEmptyStringWithUndefined(values),
      context,
      options,
    );
  };
};
